export default "__VITE_PUBLIC_ASSET__d2fb1c7d__"